"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var GAMES_BY_PAGE = 6;
var RecentAndFavoritesCollection = function (_a) {
    var _b, _c;
    var gameCardPlaceholder = _a.gameCardPlaceholder;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var router = (0, navigation_1.useRouter)();
    var recentGames = (0, swr_hooks_1.useRecentGames)().data;
    var favoriteGames = (0, swr_hooks_1.useFavoriteGames)().data;
    var filteredGames = (0, react_1.useMemo)(function () {
        var allGames = __spreadArray(__spreadArray([], (recentGames || []), true), ((favoriteGames === null || favoriteGames === void 0 ? void 0 : favoriteGames.list) || []), true);
        return Array.from(new Map(allGames.map(function (game) { return [game.id, game]; })).values());
    }, [recentGames, favoriteGames]);
    var viewAllHandler = (0, react_1.useCallback)(function () {
        router.push(generateUrlWithLang("/games/recent-favorites"));
    }, [router, generateUrlWithLang]);
    if (!isAuth ||
        !recentGames ||
        !favoriteGames ||
        ((recentGames === null || recentGames === void 0 ? void 0 : recentGames.length) === 0 && ((_b = favoriteGames === null || favoriteGames === void 0 ? void 0 : favoriteGames.list) === null || _b === void 0 ? void 0 : _b.length) === 0))
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.inner },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
                react_1.default.createElement("h3", null,
                    react_1.default.createElement("img", { src: "/img/game-filters/recent.svg", alt: "recent" }),
                    t('recentAndFavoriteGames'))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.games },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.gameItemWrapper }, (_c = filteredGames.slice(0, GAMES_BY_PAGE)) === null || _c === void 0 ? void 0 : _c.map(function (game) { return (react_1.default.createElement("div", { key: game.id },
                    !breakpoints.tablet && !breakpoints.mobile && (react_1.default.createElement(ui_components_1.DesktopGameCard, { withDemo: false, key: "search_bar_dropdown_".concat(game.id, "}"), title: game.title, slug: game === null || game === void 0 ? void 0 : game.slug, gameId: game.id, gameCardPlaceholder: gameCardPlaceholder, signUpModalKey: apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL })),
                    (breakpoints.tablet || breakpoints.mobile) && (react_1.default.createElement(ui_components_1.MobileGameCard, { key: "search_bar_dropdown_".concat(game.id, "}"), title: game.title, gameId: game.id, slug: game === null || game === void 0 ? void 0 : game.slug, gameCardPlaceholder: gameCardPlaceholder, gameInfoModalKey: apps_shared_1.POPUP_CONSTANTS.GAME_INFO_MODAL })))); }))),
            filteredGames && (react_1.default.createElement("div", { className: styles_module_scss_1.default.loadMore },
                react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", onClick: viewAllHandler }, t('viewAll')))))));
};
exports.default = RecentAndFavoritesCollection;
